import { SVColorPicker, SVButton } from '@/components/core';
import { GRID_ROW_STYLES } from '@/constants/common';
import { Card, Typography, Grid, Box, Stack } from '@mui/material';
import BrandingThemeFilePicker from './BrandingThemeFilePicker';

type WebsiteAndEmailsFormProps = {
  primaryColor: string;
  secondaryColor: string;
  buttonFontColor: string;
  logoUrl: string;
};

export default function WebsiteAndEmailsForm({
  primaryColor,
  secondaryColor,
  buttonFontColor,
  logoUrl,
}: WebsiteAndEmailsFormProps) {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Website and Emails
      </Typography>
      <Grid spacing={2} sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVColorPicker
            rules={{ required: true }}
            label="Primary Color"
            name="primaryColor"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              width: '100%',
              height: '45px',
              backgroundColor: primaryColor,
            }}
          />
        </Grid>
      </Grid>
      <Grid spacing={2} sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVColorPicker
            rules={{ required: true }}
            label="Secondary Color"
            name="secondaryColor"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              width: '100%',
              height: '45px',
              backgroundColor: secondaryColor,
            }}
          />
        </Grid>
      </Grid>
      <Grid spacing={2} sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVColorPicker
            rules={{ required: true }}
            label="Font Color on Button"
            name="buttonFontColor"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          {buttonFontColor && (
            <SVButton
              sx={{
                backgroundColor: primaryColor,
                color: buttonFontColor,
              }}>
              Button Label
            </SVButton>
          )}
        </Grid>
      </Grid>
      <Grid spacing={2} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>
            <Typography fontWeight="bold" variant="body1">
              Logo for all customer facing assets besides mobile app (i.e.
              emails, statements, bank application, etc.)
            </Typography>
            <BrandingThemeFilePicker
              name="logoUrl"
              label="Upload"
              rules={{ required: true }}
              fileName="logo"
            />
            <Typography color="grey" variant="caption">
              Please upload the following file types: JPG, JPEG, or PNG. The
              file size should be under 1MB and the aspect ratio (width/height)
              should be between 1 and 9.5.
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          {logoUrl && <img style={{ maxWidth: '100%' }} src={logoUrl} />}
        </Grid>
      </Grid>
    </Card>
  );
}
